import React from 'react'
import PropTypes from 'prop-types'

import { logout } from 'utils/auth'

import BaseComponent from 'utils/BaseComponent'

import EditAccount from './EditAccount'
import EditPassword from './EditPassword'

import './index.scss'

export default class DropDown extends BaseComponent {
  constructor(props) {
    super(props)

    this._bind('_showEditAccount', '_showEditPassword', '_onLogout')
  }

  _showEditAccount() {
    this.context.toggleModal(true,
      <EditAccount />
    )
  }

  _showEditPassword() {
    this.context.toggleModal(true,
      <EditPassword />
    )
  }

  _onLogout(e) {
    e.preventDefault()
    logout()
  }

  render() {
    return (
      <div id="dropdownMenu" className="dropdown">
        <button className="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          <button id="editAccountButton" onClick={this._showEditAccount} className="dropdown-item">Editar mi cuenta</button>
          <button id="editPasswordButton" onClick={this._showEditPassword} className="dropdown-item">Cambiar contraseña</button>
          <button id="logOutButton" onClick={this._onLogout} className="dropdown-item d-flex align-items-center justify-content-between close-sesion">
            Cerrar sesión <span className="material-icons">power_settings_new</span>
          </button>
        </div>
      </div>
    )
  }
}

DropDown.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/Header/DropDown/index.js